import React from "react";
import CrearNovedad from "../components/Novedades/CrearNovedad";

const CrearNovedadPage = () => {
  return <CrearNovedad />;
};

export default CrearNovedadPage;
